import { DEBUG, PATH } from '../constants';


const base = PATH;
const debug = DEBUG;

export async function getAllGameInfos() {
  try {
    const response = await fetch(base + 'game-infos');
    return await response.json();
  } catch (error) {
    console.error('Erreur getAllGameInfos', error);
    throw error;
  }
}

export async function getGameInfos(g) {
  try {
    const response = await fetch(base + "game-infos/g/" + g);
    return await response.json();
  } catch (error) {
    console.error('Erreur getGameInfos', error);
    throw error;
  }
}
  
export async function createGameInfos(intro, outro, lang, idGame, active) {
  try {
    const authToken = localStorage.getItem("authToken");
    const response = await fetch(base + 'game-infos/insert', {
      method: 'POST',
      credentials: "include",
      headers: { 
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${authToken}` 
      },
      body: JSON.stringify({ 
        intro, 
        outro, 
        lang, 
        id_game: idGame, 
        active 
      }),
    });
    return await response.json();
  } catch (error) {
    console.error('Erreur createGameInfos:', error);
    throw error;
  }
}

export async function updateGameInfos(idGameInfos, intro, outro, lang) {
  try {
    const authToken = localStorage.getItem("authToken");
    const response = await fetch(base + 'game-infos/update', {
      method: 'POST',
      credentials: "include",
      headers: { 
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${authToken}` 
      },
      body: JSON.stringify({ 
        intro, 
        outro, 
        lang, 
        id: idGameInfos
      }),
    });
    return await response.json();
  } catch (error) {
    console.error('Erreur createGameInfos:', error);
    throw error;
  }
}

export async function deleteGameInfos(gameInfosId) { 
    try {
        const authToken = localStorage.getItem("authToken"); 
        const response = await fetch(base + 'game-infos/delete', {
        method: 'POST',
        credentials: "include", 
        headers: { 
            'Content-Type': 'application/x-www-form-urlencoded',
            'Authorization': `Bearer ${authToken}` 
        },
        body: new URLSearchParams({id: gameInfosId }),
        });
        return await response.json();
    } catch (error) {
        console.error('Erreur deleteGameInfos', error);
        throw error;
    }
}

/**
 * Activer/désactiver une traduction
 */
export async function toggleGameInfos(id, active) {
  try {
    const authToken = localStorage.getItem("authToken");
    const response = await fetch(base + "game-infos/toggle", {
      method: 'POST',
      credentials: "include",
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${authToken}`
      },
      body: JSON.stringify({ id, active })
    });

    return await response.json();
  } catch (error) {
    console.error('Erreur toggleGameInfos:', error);
    throw error;
  }
}

  